import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@ublend-npm/aulaui-next';

import { studentGradesType } from '../../types';

import {
  Name,
  Email,
  Info,
  Container,
  Separator,
} from './StudentIdColumn.styled';

const StudentIdColumn = ({ studentGrades }) =>
  studentGrades.map(({ customStudentId, studentId }) => (
    <Fragment key={studentId}>
      <Container>{customStudentId || '  '}</Container>
      <Separator />
    </Fragment>
  ));

StudentIdColumn.propTypes = {
  studentGrades: PropTypes.arrayOf(studentGradesType).isRequired,
};

export default StudentIdColumn;
